<template>
  <transition name="toast-slide">
    <div v-if="shouldShow && !dismissed" class="notification-status-toast">
      <!-- 重连中 -->
      <el-alert
        v-if="wsState === 'reconnecting'"
        type="warning"
        :closable="true"
        show-icon
        class="status-alert compact"
        @close="handleDismiss"
      >
        <template slot="title">
          <span>通知重连中</span>
          <span v-if="wsReconnectAttempts > 0" class="attempts">
            第 {{ wsReconnectAttempts }} 次
          </span>
        </template>
      </el-alert>

      <!-- 连接失败 -->
      <el-alert
        v-if="wsState === 'failed'"
        type="warning"
        :closable="true"
        show-icon
        class="status-alert compact"
        @close="handleDismiss"
      >
        <template slot="title">
          <div class="failed-content">
            <span class="failed-title">通知连接不稳定，自动重连中</span>
            <div class="actions">
              <el-button type="primary" size="mini" @click="handleReconnect">
                立即重连
              </el-button>
              <span class="hint">已尝试 {{ wsReconnectAttempts }} 次</span>
            </div>
          </div>
        </template>
      </el-alert>

      <!-- 网络离线 -->
      <el-alert
        v-if="wsState === 'disconnected' && !isOnline"
        type="info"
        :closable="true"
        show-icon
        class="status-alert compact"
        @close="handleDismiss"
      >
        <template slot="title">
          网络离线，通知暂不可用
        </template>
      </el-alert>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'NotificationStatus',

  data() {
    return {
      isOnline: navigator.onLine,
      dismissed: false
    }
  },

  computed: {
    ...mapGetters('notification', [
      'wsState',
      'wsReconnectAttempts',
      'isWSConnected'
    ]),

    shouldShow() {
      return ['reconnecting', 'failed', 'disconnected'].includes(this.wsState)
    }
  },

  watch: {
    wsState(newState, oldState) {
      if (oldState === 'failed' && newState === 'reconnecting') {
        this.dismissed = false
      }
      if (newState === 'connected') {
        this.dismissed = false
      }
    }
  },

  mounted() {
    window.addEventListener('online', this.handleOnline)
    window.addEventListener('offline', this.handleOffline)
  },

  beforeDestroy() {
    window.removeEventListener('online', this.handleOnline)
    window.removeEventListener('offline', this.handleOffline)
  },

  methods: {
    ...mapActions('notification', ['reconnectNotificationWS']),

    handleReconnect() {
      this.dismissed = false
      this.reconnectNotificationWS()
    },

    handleDismiss() {
      this.dismissed = true
    },

    handleOnline() {
      this.isOnline = true
    },

    handleOffline() {
      this.isOnline = false
    }
  }
}
</script>

<style scoped>
.notification-status-toast {
  position: fixed;
  top: 68px;
  right: 16px;
  width: 340px;
  max-width: calc(100vw - 24px);
  z-index: 2000;
  pointer-events: none;
}

.status-alert {
  margin: 0;
  border-radius: 10px;
  pointer-events: auto;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.status-alert.compact {
  margin-bottom: 8px;
}

/* Element UI Alert 样式覆盖 */
.status-alert >>> .el-alert {
  padding: 9px 10px;
}

.status-alert >>> .el-alert__icon {
  font-size: 14px;
  width: 16px;
}

.status-alert >>> .el-alert__content {
  padding-right: 16px;
}

.status-alert >>> .el-alert__title {
  font-size: 12px;
  line-height: 1.4;
}

.status-alert >>> .el-alert__closebtn {
  top: 10px;
  right: 10px;
  font-size: 12px;
}

.attempts {
  margin-left: 6px;
  font-size: 11px;
  opacity: 0.8;
}

.failed-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.failed-title {
  display: inline-block;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions >>> .el-button--mini {
  padding: 4px 10px;
}

.hint {
  font-size: 11px;
  opacity: 0.75;
  white-space: nowrap;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.25s ease;
}

.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 768px) {
  .notification-status-toast {
    top: 58px;
    right: 8px;
    width: auto;
    max-width: calc(100vw - 16px);
  }
}
</style>
